import { Skeleton } from "@ui/skeleton";

export const CircleListSkeleton = () => {
  const skeletonData: { id: string }[] = Array.from({ length: 5 }).map(
    (s, i) => {
      return {
        id: i + "",
      };
    }
  );

  const renderItems = () => {
    return skeletonData.map((s) => {
      return (
        <div key={s.id}>
          <Skeleton
            className={`h-[200px] w-[200px] rounded-full bg-[#f4f4f5] dark:bg-[#27272a]`}
          ></Skeleton>
        </div>
      );
    });
  };

  return (
    <div className="flex w-full flex-col items-start justify-start">
      <div className="mt-4 flex w-full items-start justify-start gap-x-4">
        {renderItems()}
      </div>
    </div>
  );
};
